<template>
  <div class="logisticsDetails">
    <div class="personal-box comWidth">
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <ul class="msg" v-if="LocalTraces">
            <li  v-if="LocalTraces.length>0" v-for="(el, index) in Result[0].LocalTraces" :key="el.id">
              <p>{{el.Action}}</p>
              <p>{{el.DealTime}}</p>
              <span class="before"></span><span class="after checked"></span>
            </li>
            <li v-if="Result[0].LocalCurrentAction">
              <p>{{Result[0].LocalCurrentAction}}</p>
              <p>{{Result[0].DestCurrentDealtime}}</p>
            </li>
     <!--       <li>
              <p>2015-04-28 11:23:28</p>
              <p>到达广东省邮政速递物流有限公司中山三角邮件处理中心处理中心（经转）</p>
              <span class="before"></span><span class="after"></span>
            </li>
            <li>
              <p>2015-04-28 11:23:28</p>
              <p>到达广东省邮政速递物流有限公司中山三角邮件处理中心处理中心（经转）</p>
              <span class="before"></span><span class="after"></span>
            </li>
            <li>
              <p>2015-04-28 11:23:28</p>
              <p>到达广东省邮政速递物流有限公司中山三角邮件处理中心处理中心（经转）</p>
              <span class="before"></span><span class="after"></span>
            </li>
            <li>
              <p>2015-04-28 11:23:28</p>
              <p>到达广东省邮政速递物流有限公司中山三角邮件处理中心处理中心（经转）</p>
              <span class="before"></span><span class="after"></span>
            </li>-->
          </ul>
          <p v-else style="padding: 15px;">
            暂无物流信息
          </p>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //api
  import {tracking } from '@/api/order'
  export default {
    name: 'LogisticsDetails',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'物流跟踪信息',
        bill:this.$route.query.bill,
        logisticsList:{}, // 物流
        id:undefined, // 订单id
        Result:[], //
        LocalTraces:undefined, //
      }
    },
    methods:{
      // 获取物流详情
      getBill(){
        tracking(this.bill).then(res=>{
          this.logisticsList = res
          this.Result = res.Result
          this.LocalTraces = res.Result[0].LocalTraces
        })
      }
    },
    created(){
        this.getBill()
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "../../../css/logisticsDetails.less";
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/orderCenter/LogisticsDetails.vue